import { GET_STAT_DATA } from "../actions/types";

export default function (state = null, action: any) {
  switch (action.type) {
    case GET_STAT_DATA:
      return action.payload;
    default:
      return state;
  }
}
